<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_DIV')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <cmp-task-id-select
              ref="taskIdSelect"
              :pageId="parentPageId"
              :default1LevelOption="'all'"
              :default2LevelOption="'all'"
              :default3LevelOption="'all'"
              @select-changed="onChangeBizCodes"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USER_GRP_NAME')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="usrGrpName"
              @keyup.enter="onSearch"
              @keyup="onKeyUpInput"
            />
          </div>
          <div class="btn_wrap">
            <sui-button
              type="button"
              class="comm_btn_Reset"
              @click="onReset"
            >
              {{ $t("MSG_BTN_RESET") }}
            </sui-button>
            <sui-button
              type="button"
              class="comm_btn_Scr"
              @click="onSearch"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <sui-s-grid
        ref="grdUserGrp"
        :headers="gridColumns0"
        :data-source="dsUserGrp"
        :options="options"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCancel"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onSave"
      >
        {{ $t('MSG_BTN_SELT') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/extensions
import {urDataSet} from 'uidev-component/index.js';
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00023_P01', // eslint-disable-line vue/name-property-casing
  props: {
    parentPageId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dsUserGrp: new urDataSet(),
      options: {
        infinityScroll: true,
        noBaseInfo: false,
        internalPaging: false,
        multiSelect: true,
        selectCheck: true,
        selectCheckOnly: true,
      },
      usrGrpName: '',
      selectedBizCode: [],
      searchFieldOldText: '',
      //localdata0: [],
      // gridColumns0: [{
      //   text: this.$t('MSG_TXT_TASK_DIV'),
      //   datafield: 'taskName',
      // }, {
      //   text: this.$t('MSG_TXT_USER_GRP_NAME'),
      //   datafield: 'userGroupName',
      // }, {
      //   text: this.$t('MSG_TXT_MDFC_USR'),
      //   datafield: 'modificationUserId',
      //   createwidget: (row, column, value, htmlElement) => {
      //     utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
      //       displayType: '1', // "1", "2" - default: "1"
      //       type: 'link', // 'link', 'sublink' - default: "link"
      //       datafieldMap: {
      //         displayLanguageId: 'dsplLangId',
      //         knoxId: 'knoxId',
      //         userName: 'userName',
      //         userGlobalName: 'userGlobalName',
      //         departmentName: 'deptName',
      //         departmentEnglishName: 'deptGlobalName',
      //       },
      //     }, this.dsUserGrp, this.$refs.grdUserGrp);
      //   },
      //   initwidget(row, column, value, htmlElement) {
      //     utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      //   },
      //   width: 200,
      // }, {
      //   text: this.$t('MSG_TXT_MDFC_DT'),
      //   datafield: 'modificationDTM',
      //   width: 150,
      // }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  // datasets: [{
  //   id: 'dsUserGrp',
  //   type: 'local',
  //   data: 'localdata0',
  //   datafields: [
  //     { name: 'userGroupId', type: 'string', map: 'userGroupId' },
  //     { name: 'userGroupName', type: 'string', map: 'userGroupName' },
  //     { name: 'taskId', type: 'string', map: 'taskId' },
  //     { name: 'taskName', type: 'string', map: 'taskName' },
  //     { name: 'modificationDTM', type: 'string', map: 'modificationDTM' },
  //     { name: 'modificationUserId', type: 'string', map: 'modificationUserId' },
  //     { name: 'dsplLangId', type: 'string', map: 'dsplLangId' },
  //     { name: 'knoxId', type: 'string', map: 'knoxId' },
  //     { name: 'userName', type: 'string', map: 'userName' },
  //     { name: 'userGlobalName', type: 'string', map: 'userGlobalName' },
  //     { name: 'deptName', type: 'string', map: 'deptName' },
  //     { name: 'deptGlobalName', type: 'string', map: 'deptGlobalName' },
  //   ],
  // }],
  created() {
    this.gridColumns0 = [{
      text: this.$t('MSG_TXT_TASK_DIV'),
      value: 'taskName',
    }, {
      text: this.$t('MSG_TXT_USER_GRP_NAME'),
      value: 'userGroupName',
    }, {
      text: this.$t('MSG_TXT_MDFC_USR'),
      value: 'finalModificationUserName',
      component: {
        props: ['row', 'value'],
        template:
          `<cmp-user-name-link
            :pageId="'${this.contextPageId}'"
            :displayType="'1'"
            :displayLanguageId="row.dsplLangId"
            :userId="row.modificationUserId"
            :knoxId="row.knoxId"
            :loginId="row.loginId"
            :userName="row.userName"
            :userGlobalName="row.userGlobalName"
            :departmentName="row.deptName"
            :departmentEnglishName="row.deptGlobalName"
            :type="'link'"
          />`,
      },
      // createwidget: (row, column, value, htmlElement) => {
      //   utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
      //     displayType: '1', // "1", "2" - default: "1"
      //     type: 'link', // 'link', 'sublink' - default: "link"
      //     datafieldMap: {
      //       displayLanguageId: 'dsplLangId',
      //       knoxId: 'knoxId',
      //       userName: 'userName',
      //       userGlobalName: 'userGlobalName',
      //       departmentName: 'deptName',
      //       departmentEnglishName: 'deptGlobalName',
      //     },
      //   }, this.dsUserGrp, this.$refs.grdUserGrp);
      // },
      // initwidget(row, column, value, htmlElement) {
      //   utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      // },
      width: 200,
    }, {
      text: this.$t('MSG_TXT_MDFC_DTM'),
      value: 'modificationDTM',
      width: 150,
    }];
  },
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onChangeBizCodes(optList) {
      this.selectedBizCode = optList;
    },
    onReset() {
      this.$refs.taskIdSelect.reset();
      this.selectedBizCode = [];
      this.usrGrpName = '';
    },
    onSearch() {
      let taskId = '';

      if (this.selectedBizCode[2].key !== 'ALL') {
        taskId = this.selectedBizCode[2].key;
      } else if (this.selectedBizCode[1].key !== 'ALL') {
        taskId = this.selectedBizCode[1].key;
      } else if (this.selectedBizCode[0].key !== 'ALL') {
        taskId = this.selectedBizCode[0].key;
      }

      const queryParams = {
        taskId: taskId || '',
        searchCond: 'USR_GRP_NM',
        searchWord: this.usrGrpName || '',
        basicAuthYn: 'N',
        portalId: this.$store.getters.userInfo.portalId,
      };

      http.request(this.parentPageId, 'DTS_CMA_00008', {
        query: queryParams,
      }).then(res => {
        if (res.data) {
          const items = [];
          utils.forEach(res.data, obj => {
            const date = utils.dateformatToClient(obj.finalModificationDTM);
            items.push({
              userGroupId: obj.userGroupId,
              userGroupName: obj.userGroupName,
              taskId: obj.taskId,
              taskName: obj.taskName,
              modificationDTM: date,
              modificationUserId: obj.finalModificationUserId,
              dsplLangId: obj.dsplLangId,
              knoxId: obj.knoxId,
              userName: obj.userName,
              userGlobalName: obj.userGlobalName,
              deptName: obj.deptName,
              deptGlobalName: obj.deptGlobalName,
            });
          });

          //this.dsUserGrp.setRawData(items);
          this.dsUserGrp.setData(items);
          //this.dsUserGrp.clearSelection();
          this.$refs.grdUserGrp.resetSelect();
        } else {
          this.dsUserGrp.setData([]);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onCancel() {
      this.$emit('cancel', '');
    },
    onSave() {
      //const dsData = this.dsUserGrp.getSelectedRawData();
      const dsData = this.dsUserGrp.getSelected();
      const { siteId } = this.$store.getters.userInfo;
      utils.forEach(dsData, item => {
        item.siteId = siteId;
      });
      // const selectedIndexes = this.dsUserGrp.getSelectedIndexes();
      //
      // utils.forEach(selectedIndexes, item => {
      //   const dsInfo = this.dsUserGrp.data[item];
      //
      //   const { siteId } = this.$store.getters.userInfo;
      //
      //   const groupIdCheck = utils.findIndex(this.userData,
      //     o => utils.isEqual(utils.trim(o.userGroupId), utils.trim(dsInfo.userGroupId))
      //     && utils.isEqual(utils.trim(o.taskId), utils.trim(dsInfo.taskId)));
      //   if (groupIdCheck === -1) {
      //     dsData.push({
      //       siteId,
      //       siteName: '',
      //       taskId: dsInfo.taskId,
      //       taskName: dsInfo.taskName,
      //       userGroupId: dsInfo.userGroupId,
      //       userGroupName: dsInfo.userGroupName,
      //     });
      //   }
      // });

      if (dsData.length > 0) {
        this.$emit('save', dsData);
      } else {
        this.$emit('save', []);
      }
    },
    onKeyUpInput() {
      const searchFieldNewText = this.usrGrpName;

      if (utils.isEmpty(searchFieldNewText) === false) {
        if (utils.isExistSpecialChar(searchFieldNewText) === true) {
          this.conFirm('error', this.$t('MSG_ALT_NO_SPECL_CHAR'), null);
          this.usrGrpName = this.searchFieldOldText;
        } else {
          this.searchFieldOldText = searchFieldNewText;
        }
      }
    },
    conFirm(type, value, subValue) {
      utils.messageBox(type, value, subValue, this.onClose);
    },
  },
};
</script>
<style scoped>
</style>
